import React, { useEffect } from 'react';
import Helmet from 'react-helmet';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { List, Map } from 'immutable';

import { useInjectEpics } from 'utils/injectEpics';
import OrganizationMenu from 'retired/OrganizationMenu';
import { selectUser, selectOrganization } from 'entities/user/selectors';
import { Disclaimer } from 'entities/organization/model';

import { Privileges } from '../../utils/privileges';

import HomepageBannerForm from './HomepageBannerForm';
import SplashImageForm from './SplashImageForm';
import NotificationBannerForm from './NotificationBannerForm';
import FaqForm from './FaqForm';
import DisclaimersSection from './DisclaimersSection';
import epics from './epics';
import {
  initAction,
  saveNotificationBannerAction,
  saveFormAction,
  HomepageBannerData,
  FaqLinkData,
  SplashImageData,
  saveDisclaimersAction,
} from './actions';

const AppSettingsPage = () => {
  useInjectEpics({ key: 'AppSettingsPage', epics });
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(selectUser);
  const organization = useSelector(selectOrganization);

  useEffect(() => {
    if (user && !user.hasPrivilege(Privileges.ORGANIZATION_MANAGE_SETTINGS)) {
      history.replace('/');
    }
  });

  useEffect(() => {
    dispatch(initAction());
  }, []);

  const submitDisclaimers = (data: List<Map<string, Disclaimer>>) => {
    dispatch(saveDisclaimersAction(data.toJS()));
  };

  const submitNotificationBanner = (data: Map<string, string>) => {
    dispatch(saveNotificationBannerAction(data.toJS()));
  };

  const submitForm = (data: HomepageBannerData | FaqLinkData | SplashImageData) => {
    dispatch(saveFormAction(data));
  };

  return (
    <>
      <Helmet title="App Settings" />
      <div style={{ marginBottom: 60 }}>
        <OrganizationMenu />
      </div>
      {organization && (
        <>
          <HomepageBannerForm submitForm={submitForm} />
          <SplashImageForm submitForm={submitForm} />
          <NotificationBannerForm submitForm={submitNotificationBanner} />
          <FaqForm faqLink={organization.faqLink} submitForm={submitForm} />
          <DisclaimersSection submitForm={submitDisclaimers} />
        </>
      )}
    </>
  );
};

export default AppSettingsPage;
